import { Routes, Route } from "react-router-dom";
import TerminalLayout from "@/components/TerminalLayout";
import Dashboard from "@/pages/Dashboard";
import WalletPage from "@/pages/WalletPage";
import StrategyPage from "@/pages/StrategyPage";
import BotControlPage from "@/pages/BotControlPage";
import CrewDashboardPage from "@/pages/CrewDashboardPage";
import MarketsPage from "@/pages/MarketsPage";
import BacktestPage from "@/pages/BacktestPage";
import StrategiesPage from "@/pages/StrategiesPage";
import PortfolioPage from "@/pages/PortfolioPage";
import AIQuantPage from "@/pages/AIQuantPage";
import ChatWidget from "@/components/ChatWidget";

function App() {
  return (
    <div className="min-h-screen bg-black text-green-400 font-mono relative">
      <div className="scanline-overlay" />
      <Routes>
        <Route element={<TerminalLayout />}>
          <Route path="/" element={<Dashboard />} />
          <Route path="/portfolio" element={<PortfolioPage />} />
          <Route path="/markets" element={<MarketsPage />} />
          <Route path="/bot" element={<BotControlPage />} />
          <Route path="/crew" element={<CrewDashboardPage />} />
          <Route path="/ai-quant" element={<AIQuantPage />} />
          <Route path="/strategies" element={<StrategiesPage />} />
          <Route path="/backtest" element={<BacktestPage />} />
          <Route path="/wallet" element={<WalletPage />} />
          <Route path="/strategy" element={<StrategyPage />} />
          <Route path="/builder" element={<StrategyPage />} />
        </Route>
      </Routes>
      <ChatWidget />
    </div>
  );
}

export default App;
